import React, {useState, useEffect, createContext, useContext} from 'react';
import axios from 'axios';
import {getUserProfile} from 'api/user';

import appConfig from 'config/app';

const FetchContext = createContext();

const FetchProvider = (props) => {
  const [account, setAccount] = useState(null);
  const [refetch, setRefetch] = useState(false);

  const authAxios = axios.create({
    baseURL: appConfig.api.baseUrl
  });

  useEffect(() => {
    const fetchUserProfile = async () => {
      const response = await getUserProfile(authAxios);
      if (response?.data?.domainName) {
        setRefetch(false);
        setAccount(response.data);
      }
    };
    if (!account || refetch) {
      fetchUserProfile();
    }
  }, [authAxios, account, refetch]);

  authAxios.interceptors.request.use(
    (config) => config,
    (error) => Promise.reject(error)
  );

  authAxios.interceptors.response.use(
    (response) => response,
    (error) => {
      const code = error && error.response ? error.response.status : 0;
      if (code === 401 || code === 403) {
        console.log('error', error);
        return (window.location = `${process.env.REACT_APP_API_BASEURL}/preauth`);
      }

      return Promise.reject(error?.response?.data?.data ?? error);
    }
  );

  return <FetchContext.Provider value={{authAxios, account, refetch, setRefetch}} {...props} />;
};

function useAuthFetch() {
  const context = useContext(FetchContext);

  if (context === undefined) {
    throw new Error('useAuthFetch must be used within an FetchProvider');
  }

  const isAdmin = context?.account?.role === 'ADMIN';

  return {isAdmin, ...context};
}

export {FetchContext, FetchProvider, useAuthFetch};
